export default __webpack_public_path__ + "static/media/notifications-30days.ffea77cd.svg";